import {
  AuthenticationResult,
  EventMessage,
  EventType,
  IPublicClientApplication,
  PublicClientApplication,
  stubbedPublicClientApplication,
} from "@azure/msal-browser";
import { isAuthConfigured, msalConfig } from "authConfig";

export const msalInstance: IPublicClientApplication = isAuthConfigured
  ? new PublicClientApplication(msalConfig)
  : stubbedPublicClientApplication;

if (isAuthConfigured) {
  if (
    !msalInstance.getActiveAccount() &&
    msalInstance.getAllAccounts().length > 0
  ) {
    msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
  }

  msalInstance.addEventCallback((event: EventMessage) => {
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
      const payload = event.payload as AuthenticationResult;
      msalInstance.setActiveAccount(payload.account);
    }
  });
}
